/**
 * 표준 광역시도 — 표준 18값 중 `전국` 을 제외한 17값. 업체 소재지와 공고 찾기 지역 필터(전국은 항상 포함되는 값이라
 * 선택지가 아니다)가 같은 목록을 쓴다.
 * 폐집합 SSoT 는 `docs/data-model/08-데이터표준.md §4.20`. 순서는 백엔드 RegionNormalizer 와 동일.
 */
export const REGION_SIDO_OPTIONS = [
  '서울특별시',
  '부산광역시',
  '대구광역시',
  '인천광역시',
  '광주광역시',
  '대전광역시',
  '울산광역시',
  '세종특별자치시',
  '경기도',
  '강원특별자치도',
  '충청북도',
  '충청남도',
  '전북특별자치도',
  '전라남도',
  '경상북도',
  '경상남도',
  '제주특별자치도',
] as const;

export type RegionSido = (typeof REGION_SIDO_OPTIONS)[number];

export function isRegionSido(value: string): value is RegionSido {
  return (REGION_SIDO_OPTIONS as readonly string[]).includes(value);
}
